import { ChoiceQuestion } from "./choice-question";
import type { QuestionTypeRendererProps } from "./shared";

type MultipleChoiceQuestionProps = QuestionTypeRendererProps<"multiple_choice">;

export default function MultipleChoiceQuestionType(props: MultipleChoiceQuestionProps) {
  return <ChoiceQuestion {...props} kind="multiple_choice" />;
}
